import {
  DeadLetter,
  DeadLetterList,
  ExchangeSummary,
  InboxList,
  InboxMessage,
  InterfaceList,
  OutboxList,
  OutboxMessage,
  ReconciliationDifference,
  ReconciliationDifferencePage,
  ReconciliationRun,
  ReconciliationRunList,
  type DeadLetterDiscard,
  type DeadLetterQuery,
  type DeadLetterReplay,
  type DifferenceQuery,
  type DifferenceReview,
  type InboxQuery,
  type OutboxQuery,
  type Partner,
} from '@regigov/contracts';
import { z } from 'zod';
import { api } from './client';

const json = (body: unknown): RequestInit => ({ method: 'POST', body: JSON.stringify(body) });

function qs(query: Record<string, string | number | undefined>): string {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(query)) if (v !== undefined && v !== '') params.set(k, String(v));
  const s = params.toString();
  return s ? `?${s}` : '';
}

export const exchangeApi = {
  interfaces: () => api('/exchange/interfaces', InterfaceList),
  summary: () => api('/exchange/summary', ExchangeSummary),
  outbox: (query: Partial<OutboxQuery> = {}) => api(`/exchange/outbox${qs(query)}`, OutboxList),
  publishUnpublished: () => api('/exchange/outbox/publish-unpublished', z.object({ queued: z.number().int() }), { method: 'POST' }),
  outboxMessage: (id: number) => api(`/exchange/outbox/${id}`, OutboxMessage),
  inbox: (query: Partial<InboxQuery> = {}) => api(`/exchange/inbox${qs(query)}`, InboxList),
  inboxMessage: (id: number) => api(`/exchange/inbox/${id}`, InboxMessage),
  deadLetters: (query: Partial<DeadLetterQuery> = {}) => api(`/exchange/dead-letters${qs(query)}`, DeadLetterList),
  deadLetter: (id: number) => api(`/exchange/dead-letters/${id}`, DeadLetter),
  replay: (id: number, body: DeadLetterReplay) => api(`/exchange/dead-letters/${id}/replay`, DeadLetter, json(body)),
  discard: (id: number, body: DeadLetterDiscard) => api(`/exchange/dead-letters/${id}/discard`, DeadLetter, json(body)),
  runs: (partner?: Partner) => api(`/exchange/reconciliation${qs({ partner })}`, ReconciliationRunList),
  run: (id: number) => api(`/exchange/reconciliation/${id}`, ReconciliationRun),
  differences: (id: number, query: Partial<DifferenceQuery> = {}) => api(`/exchange/reconciliation/${id}/differences${qs(query)}`, ReconciliationDifferencePage),
  reconcile: (partner: Partner) => api('/exchange/reconciliation', ReconciliationRunList, json({ partner })),
  review: (id: number, body: DifferenceReview) => api(`/exchange/reconciliation/differences/${id}/review`, ReconciliationDifference, json(body)),
};
